
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import { vuex } from "@/store";
import rest from "@/rest";
import { namespace } from "vuex-class";
import { signalrEventBus } from "@/main";
// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
import AiPodcastCreatorDlg from "./AiPodcastCreatorDlg.vue";
// interfaces
import { courseElementTypeItems } from "@/interfaces/Types";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { CourseElementType } from "@/interfaces/CourseElementType";
import { ExBundleVM } from "@/interfaces/ExBundleAssignmentGroupVM";
import { CustomizationVm } from "@/interfaces/CustomizationVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import MarkdownEditor from "../Shared/MarkdownEditor.vue";

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
    ExpandableCard,
    AiPodcastCreatorDlg,
    MarkdownEditor
  },
})
export default class AudioPodcastElementSettings extends Vue {
  // @Prop() element!: CourseElementVm;
  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedBundle!: ExBundleVM;
  @globals.Getter selectedElement!: CourseElementVm;
  @globals.Action refreshSelectedElement!: () => Promise<void>;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;
  isBusyOnTranscription = false;
  showAiPodcastCreatorDlg = false;
  showMarkdownEditor = false;
  selectedLanguageCode = "de-DE";
  id = "";

  mounted() {
    // if (!this.selectedElement || !this.selectedBundle) return;
    if (!this.selectedBundle.sequentialModuleProcessing) {
      this.selectedElement.preventSeeking = false;
    }
  }

  created() {
    // SignalR event listener
    signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  beforeDestroy() {
    // clearAllBodyScrollLocks();
    // Make sure to cleanup SignalR event handlers when removing the component
    signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  // SignalR events
  async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
    if (this.id !== response.id) return;
    console.log("AudioPodcastElementSettings > Background task event:", response);

    if (response.status == "INF") {
      vuex.ux.SB_SUCCESS({
        message: response.message,
        timeout: 1500
      });
      return;
    }

    // Reload the element to get the updated AI summary
    await this.refreshSelectedElement();
    // Update MediaPool
    this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list

    this.isBusyOnTranscription = false;
  }

  async onCreateAiSummary(): Promise<void> {
    if (!this.selectedElement || !this.selectedBundle) return;

    await this.$l3rnOnlineHub.ensureConnection();
    this.isBusyOnTranscription = true;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
    params.dictionary!["BundleId"] = this.selectedBundle.id!.toString();
    params.dictionary!["FileName"] = this.$globalHelper.extractFileName(this.selectedElement.contentUrl ?? "");
    params.dictionary!["LanguageCode"] = this.selectedLanguageCode || "de-DE";

    await rest.url("contentManager/createAiSummary").post(params)
      .then(async (response) => {
        console.log("response", response);
        if (!response || !this.selectedElement || !this.selectedBundle) return;
        this.id = response;
      })
      .catch(err => {
      })
  }

  async onCreateAudioPodcast(): Promise<void> {
    if (!this.selectedElement!.file) {
      let guid = this.selectedElement!.guid;
      this.selectedElement!.file = `[Podcast] ${guid}.json`;
    }

    this.showAiPodcastCreatorDlg = true;
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }
}
